import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as actionTypes from './constants';
import {
  fetchWipCodesSuccess,
  fetchWipCodesFailure,
  fetchWipCodeSuccess,
  fetchWipCodeFailure,
  addWipCodeSuccess,
  addWipCodeFailure,
  updateWipCodeSuccess,
  updateWipCodeFailure,
  deleteWipCodeSuccess,
  deleteWipCodeFailure,
  fetchWipCodesForScopeSuccess,
  fetchWipCodesForScopeFailure,
  fetchWipCodesForOrderSuccess,
  fetchWipCodesForOrderFailure,
  saveWipCodesOnOrderSuccess,
  saveWipCodesOnOrderFailure,
} from './wip-codes-actions';

export function* doFetchWipCodes(action) {
  try {
    const results = yield call(callApi, {
      endpoint: 'wipcodes/aggregated',
      options: {
        errorMessage: 'Could not fetch wip codes',
        retryAction: action,
      },
    });
    yield put(fetchWipCodesSuccess(results));
  } catch (err) {
    yield put(fetchWipCodesFailure(err));
  }
}

export function* doFetchWipCodesForScope(action) {
  try {
    const results = yield call(callApi, {
      endpoint: `wipcodes/aggregated/flatten?orderId=${action.payload}`,
      options: {
        errorMessage: 'Could not fetch wip codes for scope',
        retryAction: action,
      },
    });
    yield put(fetchWipCodesForScopeSuccess(results));
  } catch (err) {
    yield put(fetchWipCodesForScopeFailure(err));
  }
}

export function* doFetchCodesForOrder(action) {
  try {
    const results = yield call(callApi, {
      endpoint: `wipcodes/order/${action.payload}`,
      options: {
        errorMessage: 'Could not fetch wip codes for order',
        retryAction: action,
      },
    });
    yield put(fetchWipCodesForOrderSuccess(results));
  } catch (err) {
    yield put(fetchWipCodesForOrderFailure(err));
  }
}

export function* doFetchWipCode(action) {
  try {
    const results = yield call(callApi, {
      endpoint: `wipcodes/${action.payload}`,
      options: {
        errorMessage: 'Could not fetch wip code',
        retryAction: action,
      },
    });
    yield put(fetchWipCodeSuccess(results));
  } catch (err) {
    yield put(fetchWipCodeFailure(err));
  }
}

export function* doAddWipCode(action) {
  const body = {
    action: action.payload.action,
    code: action.payload.code,
    description: action.payload.description,
  };
  const { scope } = action.payload;
  try {
    const results = yield call(callApi, {
      endpoint: 'wipcodes',
      options: {
        method: 'POST',
        body: JSON.stringify(body),
        errorMessage: 'Could not add wip code',
        retryAction: action,
      },
    });
    yield put(addWipCodeSuccess({ scope, ...results }));
  } catch (err) {
    yield put(addWipCodeFailure(err));
  }
}

export function* doUpdateWipeCode(action) {
  const body = {
    action: action.payload.action,
    code: action.payload.code,
    description: action.payload.description,
  };
  try {
    yield call(callApi, {
      endpoint: `wipcodes/${action.payload.id}`,
      options: {
        method: 'PUT',
        body: JSON.stringify(body),
        errorMessage: 'Could not save wip code',
        retryAction: action,
      },
    });
    // no-content response 204 response, use data to update state
    yield put(updateWipCodeSuccess(action.payload));
  } catch (err) {
    yield put(updateWipCodeFailure(err));
  }
}

export function* doSaveWipCodesForOrder(action) {
  const body = {
    wipCodeIds: action.payload.wipCodeIds || [],
    assignedDateUtc: action.payload.assignedDateUtc || null,
  };
  try {
    yield call(callApi, {
      endpoint: `wipcodes/order/${action.payload.orderId}`,
      options: {
        method: 'PUT',
        body: JSON.stringify(body),
        errorMessage: 'Could not save wip codes for order',
        retryAction: action,
      },
    });
    // no-content response/204 response, no need to indicate that something changed/saved
    yield put(saveWipCodesOnOrderSuccess(action.payload));
  } catch (err) {
    yield put(saveWipCodesOnOrderFailure(err));
  }
}

export function* doDeleteWipCode(action) {
  try {
    yield call(callApi, {
      endpoint: `wipcodes/${action.payload.id}`,
      options: {
        method: 'DELETE',
        errorMessage: 'Could not delete wip code',
        retryAction: action,
      },
    });
    // no-content response 204 response, use data to update state
    yield put(deleteWipCodeSuccess(action.payload));
  } catch (err) {
    yield put(deleteWipCodeFailure(err));
  }
}

function* watchFetchWipCodes() {
  yield takeLatest(actionTypes.FETCH_WIP_CODES_REQUEST, doFetchWipCodes);
}

function* watchFetchWipCodesForScope() {
  yield takeLatest(actionTypes.FETCH_WIP_CODES_SCOPE_REQUEST, doFetchWipCodesForScope);
}

function* watchFetchCodesForOrder() {
  yield takeLatest(actionTypes.FETCH_WIP_CODES_ORDER_REQUEST, doFetchCodesForOrder);
}

function* watchFetchWipCode() {
  yield takeLatest(actionTypes.FETCH_WIP_CODE_REQUEST, doFetchWipCode);
}

function* watchAddWipCode() {
  yield takeLatest(actionTypes.ADD_WIP_CODE_REQUEST, doAddWipCode);
}

function* watchUpdateWipCode() {
  yield takeLatest(actionTypes.UPDATE_WIP_CODE_REQUEST, doUpdateWipeCode);
}

function* watchDeleteWipCode() {
  yield takeLatest(actionTypes.DELETE_WIP_CODE_REQUEST, doDeleteWipCode);
}

function* watchSaveWipCodesForOrder() {
  yield takeLatest(actionTypes.SAVE_WIP_CODES_ORDER_REQUEST, doSaveWipCodesForOrder);
}

export default [
  fork(watchFetchWipCodes),
  fork(watchFetchWipCodesForScope),
  fork(watchFetchWipCode),
  fork(watchFetchCodesForOrder),
  fork(watchAddWipCode),
  fork(watchUpdateWipCode),
  fork(watchDeleteWipCode),
  fork(watchSaveWipCodesForOrder),
];
